// Packages
import { useLocation, Outlet, Navigate } from "react-router-dom";
import { useAuth, UserRole } from "../../context/authprovider";

const RequiredAuth = ({ allowedRoles }: { allowedRoles?: UserRole[] }) => {
    const { isAuthenticated, role } = useAuth();
    const location = useLocation();

    const hasRoles = () => {
        if (!allowedRoles) {
            return true;
        }

        if (!role) {
            return false;
        }

        return allowedRoles.includes(role);
    }

    return (
    //     hasRoles()
    // ? <Outlet />
    // : isAuthenticated 
    //     ? <Navigate to="/" state={{ from: location }} replace />
    //     : <Navigate to="/login" state={{ from: location }} replace />

        hasRoles() ? <Outlet /> : 
        isAuthenticated ? 
        role === "accManager" ?  <Navigate to="/managepanel" state={{ from: location }} replace /> : <Navigate to="/" state={{ from: location }} replace />
        : <Navigate to="/login" state={{ from: location }} replace />
    );
}

export default RequiredAuth;